import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "scroll-wrapper"
  }, [_c('div', {
    staticClass: "scroll-content"
  }, [_c('div', {
    ref: "scroll-content",
    staticStyle: {
      "padding-top": "0.36rem"
    }
  }, [_vm._t("default", function () {
    return [_vm._m(0)];
  })], 2), _vm._t("pullup", function () {
    return [_vm.pullUpLoad ? _c('div', {
      staticClass: "pullup-wrapper"
    }, [!_vm.isPullUpLoad ? _c('div', {
      staticClass: "before-trigger"
    }, [!_vm.noData ? _c('span', {
      staticClass: "no-more"
    }, [_vm._v(_vm._s(_vm.pullUpTxt))]) : _vm._e()]) : _c('div', {
      staticClass: "after-trigger"
    }, [_vm._m(1)])]) : _vm._e()];
  }, {
    "pullUpLoad": _vm.pullUpLoad,
    "isPullUpLoad": _vm.isPullUpLoad
  })], 2), _vm._t("pulldown", function () {
    return [_vm.pullDownRefresh ? _c('div', {
      ref: "pulldown",
      staticClass: "pulldown-wrapper",
      style: _vm.pullDownStyle
    }, [_vm.beforePullDown ? _c('div', {
      staticClass: "before-trigger"
    }, [_vm._m(2)]) : _c('div', {
      staticClass: "after-trigger"
    }, [_vm.pulling ? _c('div', {
      staticClass: "loading"
    }, [_c('img', {
      staticClass: "scroll-loading",
      attrs: {
        "src": "spa_static_mobile/icon/loading32_32.png"
      }
    }), _c('span', [_vm._v(i18n.tc("392"))])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.refreshTxt))])])])]) : _vm._e()];
  }, {
    "pullDownRefresh": _vm.pullDownRefresh,
    "pullDownStyle": _vm.pullDownStyle,
    "beforePullDown": _vm.beforePullDown,
    "pulling": _vm.pulling,
    "bubbleY": _vm.bubbleY
  })], 2);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "no-result-body"
  }, [_c('div', {
    staticClass: "no-result"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/none.png"
    }
  })])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    staticClass: "scroll-loading",
    attrs: {
      "src": "/spa_static_mobile/icon/loading32_32.png"
    }
  }), _c('span', [_vm._v(i18n.tc("393"))])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    staticClass: "scroll-loading",
    attrs: {
      "src": "spa_static_mobile/icon/loading32_32.png"
    }
  }), _c('span', [_vm._v(i18n.tc("394"))])]);
}];
export { render, staticRenderFns };